import { useEffect, useState } from "react";
import ChatContext from "./ChatContext";
import useHttp from "../hooks/useHttp";
import { API_URL } from "../services/api";

const ChatProvider = (props) => {
  const [connectionId, setConnectionId] = useState();
  const [refresh, setRefresh] = useState(true);
  const [chatTitle, setChatTitle] = useState('');
  const [agentId, setAgentId] = useState(null);
  const [token, setToken] = useState('');
  const [agentContextMapping, setAgentContextMapping] = useState([]);
  const [chatSectionChatTitleList, setChatSectionChatTitleList] = useState([]);
  const {getRequest, postRequest} = useHttp();
  // useEffect(() => {
  //   getRequest({
  //     url: API_URL + '/app/getSessionAttributes',
  //     onResponse: (response) => {
  //       setAgentId(response?.agentId);
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //     }, showLoader: false
  //   });
  // }, []);

  // useEffect(() => {
  //   if(agentId){
  //   postRequest({
  //     url: API_URL + '/app/setSessionAttributes?'+'agentId=' + agentId,
  //     onResponse: (response) => {
  //       setRefresh(!refresh)
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //       }, showLoader: false
  //     });
  //   }
  // }, [ agentId]);
  return (
    <ChatContext.Provider
      value={{
        setConnectionId,
        connectionId,
        onChatRefresh: () => setRefresh(!refresh),
        isChatRefresh: refresh,
        setChatTitle,
        chatTitle,
        setAgentId,
        agentId,
        setToken,
        token,
        setAgentContextMapping,
        agentContextMapping,
        setChatSectionChatTitleList,
        chatSectionChatTitleList,
      }}
    >
      {props.children}
    </ChatContext.Provider>
  );
};
export default ChatProvider;